// extracted by mini-css-extract-plugin
module.exports = {"boxList":"_3YnRueTJ-NcLjbZg4WDLGI","borderBottom":"_2ZL2hajn-bDbG3wufWodfG"};